/* eslint-disable */
import { LibCategories } from "src/utils/consent";
import { loadScript } from "src/utils/scriptLoader";

declare const window: Window & {
  pdst: any;
};

var id = "pdst-capture";
if (!document.getElementById(id)) {
  window.pdst =
    window.pdst ||
    function () {
      (window.pdst.q = window.pdst.q || []).push(arguments);
    };
}
window.pdst("conf", { key: "e06e865b728548baa6864f43c3850239" });
window.pdst("view");

export function loadPodSights() {
  return loadScript("https://cdn.pdst.fm/ping.min.js", [
    LibCategories.targetingCookies,
  ]);
}
